import axios from '../axios'
import { GOOGLEAPIROUTES } from 'src/router/Api'

export const getGoogleGeocodeStats = async (date?: string) => {
	return await axios.get(GOOGLEAPIROUTES.geocodeStats, {
		params: date ? { date } : undefined,
	})
}

export const getGooglePlacesTextSearchStats = async (date?: string) => {
	return await axios.get(GOOGLEAPIROUTES.placesTextSearchStats, {
		params: date ? { date } : undefined,
	})
}

export const getGooglePlacesAutocompleteStats = async (date?: string) => {
	return await axios.get(GOOGLEAPIROUTES.placesAutocompleteStats, {
		params: date ? { date } : undefined,
	})
}
